import { INotification } from "infrastructure/notification";
import { ITenant, IEnterprise, ISecurityRole } from "ui/screens/security/models";

export interface ISecurityRoleMember {
  userId: string;
  user: string;
  tenantId: string;
  tenantName: string;
  validDateFrom?: string;
  validDateTo?: string;
  enterpriseWide?: boolean;
}

export interface ISecurityRoleMembersFilter {
  enterprise?: IEnterprise;
  tenant?: ITenant;
  securityRole?: ISecurityRole;
}

export interface ISecurityRoleMembersState {
  isLoading: boolean;
  notifications: INotification[];
  filter?: ISecurityRoleMembersFilter;
  items?: ISecurityRoleMember[];
  selectedItems: ISecurityRoleMember[];
  grantRoleCompleted?: boolean;
}

export const getInitialSecurityRoleMembersState = (): ISecurityRoleMembersState => ({
  isLoading: false,
  notifications: [],
  selectedItems: []
});
